module.exports = __webpack_public_path__ + "static/media/3DPPA9.5cf96fd2.jpg";